module.exports = __webpack_public_path__ + "img/ring_g_s_null_1.ef7e426e.png";